import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobeComponent } from '../globe/globe.component';
import { SessionOptionsDialogComponent } from './session-options-dialog/session-options-dialog.component';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  catchError,
  forkJoin,
  map,
  Observable,
  Subject,
  throwError,
  switchMap,
  of,
  Subscription,
  interval,
  takeUntil,
  tap,
  exhaustMap,
} from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Organization } from '../../../core/models/model';
import { OrgPaneComponent } from '../organization/org-pane/org-pane.component';
import { UsersListComponent } from '../organization/users-list/users-list.component';
import { FacilitiesListComponent } from '../organization/facilities-list/facilities-list.component';
import { AlertService } from '../../../core/services/alert.service';
import { IncidentService } from '../../../core/services/incident.service';
import { AlertComponent } from '../alert/alert.component';
import { IncidentComponent } from '../incident/incident.component';
import { OrganizationService } from '../../../core/services/organization.service';
import { Perimeter } from '../../../core/models/perimter.model';
import { Alert } from '../../../core/models/alert.model';
import { Incident } from '../../../core/models/incident.model';
import { DeviceService } from '../../../core/services/device.service';
import {
  Facility,
  Group,
  GroupList,
  OrgData,
  OrgTreeNode,
  User
} from '../../../core/models/organization.interface';
import { CameraListComponent } from '../organization/camera-list/camera-list.component';
import _ from 'lodash';
import { OrganizationUtilService } from '../../../core/services/organization-util.service';
import { SessionOptionsService } from '../../../core/services/session-option.service';
import { GeofencesListComponent } from '../organization/geofences-list/geofences-list.component';
import { GeofenceService } from '../../../core/services/geofence.service';
import { OverLappingEntitiesComponent } from '../over-lapping-entities/over-lapping-entities.component';
import { OverlappingEntitiesService } from '../../../core/services/overlapping-entities.service';
import { CameraService } from '../../../core/services/camera.service';
import { CdrGlobeService } from '../../../core/services/cdr-globe.service';
import { BuildingCameraComponent } from '../building-camera/building-camera.component';
import { TravelersListComponent } from '../organization/travelers-list/travelers-list.component';
import { GroupListComponent } from '../organization/group-list/group-list.component';
import { GlobalSettingsService } from '../../../core/services/global-settings.service';
import { TimelinesUiComponent } from '../timeline/timelines-ui/timelines-ui.component';
import { WrenchActionDrawerComponent } from '../wrench-action-drawer/wrench-action-drawer.component';
import { IncidentCategoryService } from '../../../core/services/incident-category.service';
import { FixedPerimeterCreatorButtonComponent } from '../fixed-perimeter-creator-button/fixed-perimeter-creator-button.component';
import { PinActivationDialogComponent } from '../pin-activation-dialog/pin-activation-dialog.component';
import { DataService } from '../../../core/services/data.service';
import { ArcAngelMonitorModeService } from '../arc-angel-monitor-mode.service';
import { ArcAngelLiveModeService } from '../../../core/services/arc-angel-live-mode.service';
import { ViewChild } from '@angular/core';
import moment from 'moment';
import { ArcAngelModesService } from '../../../core/services/arc-angel-modes.service';
import { GeofenceCreationButtonComponent } from '../organization/geofences-list/geofence-creation-button/geofence-creation-button.component';
import { MessagesListComponent } from '../messages-list/messages-list.component';
import { FloorService } from '../../../core/services/floor.service';
import { ProcallsListComponent } from '../procalls-list/procalls-list.component';
import { ActiveTrackingListComponent } from '../active-tracking-list/active-tracking-list.component';
import { DataFeedNotificationService } from '../../../core/services/data-feed-notification.service';
import { IllumLiveService } from '../../../core/services/illum-live.service';
import { AdHocMessageWindowComponent } from '../ad-hoc-message-window/ad-hoc-message-window.component';
import * as Cesium from 'cesium';
import { SafezoneCreatorComponent } from '../safezone-creator/safezone-creator.component';
import { CoresService } from '../../../core/services/cores.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrgTreeComponent } from '../org-tree/org-tree';
import { ThreeIntegrationService } from '../../../core/services/three-js-building.service';
import { CampusListComponent } from '../organization/campus-list/campus-list.component';
import { BuildingInfo } from '../building-info/building-info';
import * as THREE from 'three';
import { BuildingStateService } from '../../../core/services/building-state.service';

interface CountryListItem {
  name: string;
  code: string;
  display: string;
  latLonRange?: {
    maxLat: number;
    minLat: number;
    maxLon: number;
    minLon: number;
  };
}

const DATAFEED = 0;
const INCIDENTS = 1;
const PROCALLS = 2;
const ORG = 3;
const BUILDINGS = 4;
const PERIMETERS = 5;
const USERS = 6;
const DEPARTMENTS = 7;
const UNITS = 8;
const GROUPS = 9;
const TRAVELERS = 10;
const MESSAGING = 11;
const REMOTES = 12;
const ALERTS = 13;
const GEOFENCES = 14;
const TASKS = 15;
const REPORTS = 16;
const CALENDAR = 17;
const ACTIVE_TRACKING = 18;
const CAMERAS = 19;
const ALERT = 20;
const INCIDENT = 21;

const CAMPUS = 21;
@Component({
  selector: 'app-session-options',
  standalone: true,
  imports: [
    CommonModule,
    GlobeComponent,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    OrgPaneComponent,
    FacilitiesListComponent,
    CampusListComponent,
    AlertComponent,
    IncidentComponent,
    CameraListComponent,
    GeofencesListComponent,
    OverLappingEntitiesComponent,
    BuildingCameraComponent,
    TravelersListComponent,
    GroupListComponent,
    TimelinesUiComponent,
    UsersListComponent,
    WrenchActionDrawerComponent,
    FixedPerimeterCreatorButtonComponent,
    GeofenceCreationButtonComponent,
    MessagesListComponent,
    ProcallsListComponent,
    ActiveTrackingListComponent,
    AdHocMessageWindowComponent,
    SafezoneCreatorComponent,
    OrgTreeComponent,
    BuildingInfo,
  ],
  templateUrl: './session-options.component.html',
  styleUrl: './session-options.component.css',
})
export class SessionOptionsComponent implements OnInit, OnDestroy {

  selectedBuilding: any = null;
  popupX = 0;
  popupY = 0;
  activeObject: THREE.Object3D | null = null;

  sessionStyle: any = { background: '#30323B' };
  sessionName: string = 'Monitor Mode';
  showLive: boolean = true;
  sessionOrganization: string = '';
  sessionObject: string = '';
  elapsed_time: string = '';
  isOpen: boolean = false;
  drawerOpen: boolean = false;
  isMonitorMode: boolean = false;
  showOrgTreePanel: boolean = false;
  orgTree: OrgTreeNode[] = [];
  showOrg: boolean = false;

  defaultCameraState: boolean = false;
  showTimeElapsed: boolean = false;
  activeAlertsCount: number = 0;
  activeincidents: number = 0;
  openprocalls: number = 0;
  opentracking: number = 0;
  isDemoUser: boolean = false;
  buildingscheckbox: boolean = false;
  earthquakecheckbox: boolean = false;
  demo2checkbox: boolean = false;
  covidcheckbox: boolean = false;
  showUsers: boolean = false;
  showFacilities: boolean = true;
  showTravelers: boolean = true;
  showRemotes: boolean = true;
  showGeofences: boolean = true;
  showHomeLocation: boolean = true;
  showStorm: boolean = true;
  showOrgSelectionMenu: boolean = false;
  orgSearch: any[] = [];
  selectedOrg: any;
  groupList: any[] = [];
  orgTreeSearch: string = '';
  actions: any = {
    twitter: false,
    genetec: true,
    geofenceAlerting: true,
    calendar: true,
    email: false,
    sms: false,
    notification: false,
    showHomeLocations: false,
    accuWeather: false,
    flightAware: false,
  };

  _numSelectedTopLevel = 0;
  private activeTab: number = DATAFEED;
  private destroy$ = new Subject<void>();
  public notificationsList: Alert[] = [];
  selectedTab: 'alerts' | 'incidents' | 'procalls' | 'tracking' | 'messaging' =
    'alerts';
  perimterInfo: Perimeter[] = [];
  incidentDetails: Incident[] = [];
  facilities: Facility[] = [];
  users: any[] = [];
  phoneNumbers: any[] = [];
  organizations: any[] = [];
  cameras: any[] = [];
  geofences: any[] = [];
  private dataCache: {
    facilities?: Facility[];
    users?: any[];
    organizations?: Organization[];
    cameras?: any[];
    geofences?: any[];
    lastUpdated?: number;
  } = {};
  entities: any[] = [];
  position: any;
  entity: any = {};
  private overlappingEntitiesSub!: Subscription;
  private entityCameraSub!: Subscription;
  private _orgTreeNodes: Record<string, OrgTreeNode> = {};
  private _orgTreeItemList: OrgTreeNode[] = [];
  numSelectedTopLevel = 0;
  private homeLocationDataSource: any;
  private homeLocationGeoJson: any;
  private viewer: any;
  userCount: any;
  isToolActive = false;
  public geofenceResults: any = null;
  showFixedPerimeterCreator = false;
  fixedPerimeterCreationId: number | null = null;
  showPinDialog = false;
  pinDialogData: any = null;
  private modeSub!: Subscription;
  showBuildingCamera = true;
  isToggleMenu = true;
  @ViewChild('alertList') alertList!: AlertComponent;
  pollerIncidentCountFromOrganization: Subscription | undefined;
  pollerAlertNotification: Subscription | undefined;
  showGeofenceCreator = false;
  drawnGeofencePolygon: number[][] | null = null;
  adhocMessageWindowVisible: boolean = false;
  isAddSafeZone: boolean = false;
  safeZoneEventId: string | null = null;
  allUserItems: User[] = [];
  allUserItemsFiltered: User[] = [];
  selectedState: any;
  selectedCity: any;
  selectedCountry?: CountryListItem;
  hasCampusAdmin: boolean = false;

  constructor(
    private modalService: NgbModal,
    private alertService: AlertService,
    private incidentService: IncidentService,
    private device: DeviceService,
    private organizationService: OrganizationService,
    private organizationUtilService: OrganizationUtilService,
    private sessionOptionsService: SessionOptionsService,
    private geofenceService: GeofenceService,
    private overlappingEntitiesService: OverlappingEntitiesService,
    public cameraService: CameraService,
    private globalSettings: GlobalSettingsService,
    private incidentCategoryService: IncidentCategoryService,
    private dataService: DataService,
    private arcAngelMonitorModeService: ArcAngelMonitorModeService,
    private arcAngelLiveModeService: ArcAngelLiveModeService,
    private arcAngelModesService: ArcAngelModesService,
    private floorService: FloorService,
    private dataFeedNotificationService: DataFeedNotificationService,
    private illumLiveService: IllumLiveService,
    private core: CoresService,
    private spinnerService: NgxSpinnerService,
    private buildingStateService: BuildingStateService,
    private cdrGlobeService: CdrGlobeService
  ) { }

  onSafeZoneCancel() {
    this.isAddSafeZone = false;
  }

  ngOnDestroy(): void {
    this.modeSub?.unsubscribe();
    this.overlappingEntitiesSub?.unsubscribe();
    this.entityCameraSub?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    this.arcAngelMonitorModeService.clearIncidents();
    this.sessionOptionsService.setMode('Monitor Mode');
    this.selectedBuilding = null;
    this.buildingStateService.clearBuildingState();
  }

  ngOnInit(): void {
    this.spinnerService.show();
    this.setShowLive(true);
    this.drawerOpen = true;
    this.isMonitorMode = true;
    this.showLive = true;
    this.viewer = this.core.getViewer();
    this.getBuildingPerimeterInfo();
    this.getOrganizationDataForMap();
    this.organizationTabList();

    this.buildingStateService.selectedBuilding$
      .pipe(takeUntil(this.destroy$))
      .subscribe((building) => {
        this.selectedBuilding = building;
      });

    this.floorService.safeZoneStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe((status) => {
        this.isAddSafeZone = status.isActive;
        this.safeZoneEventId = status.eventId || null;
      });

    this.buildingStateService.popupPosition$
      .pipe(takeUntil(this.destroy$))
      .subscribe((position) => {
        this.popupX = position.x;
        this.popupY = position.y;
      });

    this.overlappingEntitiesSub =
      this.overlappingEntitiesService.overlappingEntities$.subscribe((data) => {
        this.entities = data.entities;
        this.position = data.position;
      });
    this.entityCameraSub = this.cameraService.entityCamera$.subscribe(
      (entity) => {
        if (entity && entity?.id) {
          this.openBuildingCamera(entity);
        } else {
          this.entity = null;
        }
      }
    );
    // Listen for the request to show the Focal Point UI
    this.incidentCategoryService.showDataEntryView$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ creationId }) => {
        this.showFixedPerimeterCreator = true;
        this.isToolActive = true;
        this.fixedPerimeterCreationId = creationId;
      });
    this.modeSub = this.sessionOptionsService.mode$.subscribe((mode) => {
      this.sessionName = mode;
      this.updateSessionStyle();
      this.entity = null;
      this.floorService.toggleGrandchild(false);
      this.floorService.updateIncidentVisualizer(false);
      if (mode === 'Live Mode') {
        this.showBuildingCamera = false;
        setTimeout(() => {
          this.showBuildingCamera = true;
        });
      } else {
        this.entity = null;
      }
    });

    // ** show the count of the active incidents
    this.arcAngelMonitorModeService.monitorEvents$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.activeincidents = this.arcAngelMonitorModeService.data?.numberOfActiveIncidents || 0;
      });
    this.organizationService.orgTreeUpdated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.onOrgTreeUpdated();
      });
  }
  openBuildingCamera(entity: any) {
    if (this.entity && this.entity.id && this.entity.id === entity.id) {
      return;
    }
    if (this.entity && this.entity.id) {
      return;
    }
    this.entity = entity;
    // Mark building camera as open
    this.cameraService.setIsBuildingCameraOpen(true);
  }
  organizationTabList() {
    this.loadAllLists();
    this.loadGroupList();
  }
  organizationTree() {
    this.buildOrgTree().subscribe({
      next: (orgTree) => {
        this.organizations = orgTree;
        this.orgTree = this.organizations;
        this.updateOrgTreeItemList();
      },
      error: (error) => {
        // Error building org tree
      },
    });
  }

  private loadAllLists(): void {
    // Check if we have cached data that's less than 2 seconds old
    const now = Date.now();
    if (this.dataCache.lastUpdated && now - this.dataCache.lastUpdated < 2000) {
      this.facilities = this.dataCache.facilities || [];
      this.users = this.dataCache.users || [];
      this.cameras = this.dataCache.cameras || [];
      this.geofences = this.dataCache.geofences || [];
      return;
    }

    forkJoin({
      facilities: this.organizationService.getFacilities(),
      users: this.organizationService.getAllUsersForOrgViaAPI(),
      cameras: this.organizationService.getSensorList(),
      geofences: this.geofenceService.getGeofences(),
      phoneNumbers: this.organizationService.getPhoneNumbers(),

    }).subscribe({
      next: ({ facilities, users, cameras, geofences, phoneNumbers }) => {
        // Process facilities data
        this.facilities = Array.isArray(facilities)
          ? facilities.map((facility: any) => ({
            ...facility,
            coordinates: facility.geometry?.coordinates || [0, 0],
            geometry: facility.geometry ?? { coordinates: [0, 0] },
            attributes: {
              ...facility.attributes,
              poc: facility.attributes?.poc ?? [],
              address: facility.attributes?.address ?? '',
              basePerimeterId: facility.attributes?.basePerimeterId ?? '',
              bluetooth: facility.attributes?.bluetooth ?? false,
              extraInformation: facility.attributes?.extraInformation,
            },
          }))
          : facilities ?? [];

        this.users = users ?? [];
        this.userCount = users?.length ?? 0;

        // Process cameras data
        this.cameras = cameras?.cameraList ?? [];

        // Process geofences data
        this.geofences = geofences ?? [];
        this.organizationTree();
        this.dataCache = {
          facilities: this.facilities,
          users: this.users,
          cameras: this.cameras,
          geofences: this.geofences,
          lastUpdated: now,
        };
        this.phoneNumbers = phoneNumbers?.rows ?? [];
      },
      error: (error) => {
        // Error loading lists
      },
    });
  }

  private getBuildingPerimeterInfo(): void {
    forkJoin({
      perimeters: this.organizationService.getPerimeters(),
      // orgPerimeters: this.organizationService.getOrganizationPerimeters(),
      // orgs: this.organizationService.getOrganizations(),
    }).subscribe({
      next: async ({ perimeters }) => {
        if (perimeters && perimeters.rows.length > 0) {
          this.perimterInfo = perimeters.rows;
          this.getAlertNotification();
          this.alertService.startAlertRunner();
        } else {
          this.perimterInfo = [];
        }
      },
    });
  }
  private getIncidentFromOrganization() {
    this.pollerIncidentCountFromOrganization = interval(2000)
      .pipe(
        takeUntil(this.destroy$),
        exhaustMap(() => this.getIncidentCountFromOrganizationObservable())
      )
      .subscribe();
  }

  private getAlertNotification() {
    this.pollerAlertNotification = interval(2000)
      .pipe(
        takeUntil(this.destroy$),
        exhaustMap(() => this.getAlertNotificationsObservable())
      )
      .subscribe();
  }
  private stopIncidentPolling(): void {
    if (this.pollerIncidentCountFromOrganization) {
      this.pollerIncidentCountFromOrganization.unsubscribe();
      this.pollerIncidentCountFromOrganization = undefined;
    }
    if (this.pollerAlertNotification) {
      this.pollerAlertNotification.unsubscribe();
      this.pollerAlertNotification = undefined;
    }
  }
  private async getOrganizationDataForMap(): Promise<void> {
    this.spinnerService.show();

    this.organizationService.getOrganizations().pipe(
      map((orgs: any) => (orgs?.rows || []).map((org: any) => org.id)),
      switchMap((organizationIds: number[]) => {
        return this.organizationService.requestCampusActionSessionWithOrganizationIds().pipe(
          catchError(() => of(null)),
          switchMap((campusActionSession: any) => {
            this.hasCampusAdmin = false;
            if (campusActionSession && campusActionSession.rows && campusActionSession.rows.length > 0) {
              this.hasCampusAdmin = true;
            }

            const campusObservable: Observable<any> = this.hasCampusAdmin
              ? this.organizationService.getOrganizationCampus(organizationIds)
              : of(null);

            return forkJoin({
              perimeters: this.organizationService.getPerimeters(),
              orgPerimeters: this.organizationService.getOrganizationPerimeters(),
              orgs: this.organizationService.getOrganizations(),
              OrganizationContactFindAndCountAll: this.organizationService.OrganizationContactFindAndCountAll(),
              GroupFindAndCountAll: this.organizationService.GroupFindAndCountAll(),
              PerimeterContactFindAndCountAll: this.organizationService.PerimeterContactFindAndCountAll(),
              PerimeterSafezoneFindAndCountAll: this.organizationService.PerimeterSafezoneFindAndCountAll(),
              BuildingFindAndCountAll: this.organizationService.BuildingFindAndCountAll(),
              FloorFindAndCountAll: this.organizationService.FloorFindAndCountAll(),
              FloorPlanFindAndCountAll: this.organizationService.FloorPlanFindAndCountAll(),
              GeofenceFindAndCountAllFromOrganization: this.organizationService.GeofenceFindAndCountAllFromOrganization(),
              BeaconFindAndCountAll: this.organizationService.BeaconFindAndCountAll(),
              BuildingViewFindAndCountAll: this.organizationService.BuildingViewFindAndCountAll(),
              BuildingTileFindAndCountAll: this.organizationService.BuildingTileFindAndCountAll(),
              campuses: campusObservable
            });
          })
        );
      })
    ).subscribe({
      next: async (results: any) => {
        try {
          if (!results) return;

          this.geofenceResults = results.GeofenceFindAndCountAllFromOrganization;

          await this.organizationUtilService.processOrganizations(
            results,
            results.orgPerimeters,
            results.perimeters,
            results.campuses
          );

          const campusRows = Array.isArray(results.campuses) ? results.campuses : (results.campuses?.campuses || []);
          const buildingRows = results.BuildingFindAndCountAll?.rows || [];
          const campusId = campusRows[0]?.campusId;

          const userOrgId = (localStorage.getItem('PAA_org') ?? '').trim();
          if (userOrgId === '2025') {
            this.cdrGlobeService.flyToNigeria();
          } else if (campusRows.length >= 1) {
            const campusView = true;
            const coords = campusRows[0]?.campusPosition?.coordinates;
            if (coords?.length === 2) {
              const destination = Cesium.Cartesian3.fromDegrees(
                coords[0],
                coords[1],
                5000
              );

              this.cameraService.flyTo({
                destination,
                complete: () => {
                  const building = this.organizationUtilService.data?.myBuildings?.find(
                    (b: any) => Number(b.perimeterId) === Number(campusId)
                  );
                  const entity = building?.pin;
                  entity?.viewDetailsWindow?.(entity);
                }
              });
            }
          } else if (buildingRows.length === 1) {
            const coords = buildingRows[0]?.position?.coordinates;
            if (coords?.length === 2) {
              const destination = Cesium.Cartesian3.fromDegrees(
                coords[0],
                coords[1],
                500
              );

              this.cameraService.flyTo({
                destination,
                complete: () => {
                  const entity =
                    this.organizationUtilService.data?.myBuildings?.[0]?.pin;
                  entity?.viewDetailsWindow?.(entity);
                }
              });
            }
          }

          this.startArcAngelModesService();

        } finally {
          this.spinnerService.hide();
        }
      },
      error: (error) => {
        console.error('Map data load failed', error);
        this.spinnerService.hide();
      }
    });
  }
  startArcAngelModesService() {
    this.arcAngelModesService
      .startArcAngelService(this.sessionName, 'eventId', 'INCIDENT', this)
      .subscribe({
        next: (result) => {
          setTimeout(() => {
            this.spinnerService.hide();
          }, 5000);
        },
        error: (error) => {
          // Service start failed
        },
      });
  }

  private getAlertNotificationsObservable(): Observable<any> {
    return this.alertService.getAlertNotifications().pipe(
      tap((response) => {
        if (response && response.rows.length > 0) {
          this.activeAlertsCount = this.dataFeedNotificationService.getNotificationsActive();
          this.notificationsList = response.rows;
          if (this.notificationsList) {
            this.notificationsList.forEach((alert) => {
              if (
                alert?.viewedAt &&
                alert?.viewedAt.toLowerCase() !== 'infinity'
              ) {
                alert.alertRead = true;
              } else {
                alert.alertRead = false;
              }
              if (
                alert.dismissedAt &&
                alert.dismissedAt.toLowerCase() !== 'infinity'
              ) {
                alert.status = 'dismissed';
              } else if (
                alert.expiresAt &&
                alert.expiresAt.toLowerCase() !== 'infinity' &&
                moment(alert.expiresAt).unix() < moment().unix()
              ) {
                alert.status = 'expired';
              } else {
                alert.status = 'active';
              }
              const perimeterIds = Array.from(
                new Set([
                  ...(alert.sensorPerimeterIds || []),
                  ...(alert.perimeterIds ? alert.perimeterIds : []),
                ])
              );

              for (const id of perimeterIds) {
                const idStr = id.toString();
                const perimeterData = this.perimterInfo.find(
                  (x) => x.id.toString() === idStr.toString()
                );
                if (perimeterData) {
                  alert.buildingInfo = this.getBuildingInfo(
                    this.perimterInfo,
                    id,
                    perimeterData
                  );
                }
              }
            });
            this.updateBuildingAlertCounts();
          }
        } else {
          this.notificationsList = [];
          this.activeAlertsCount = 0;
          this.updateBuildingAlertCounts();
        }
      }),
      catchError((error) => {
        // Error fetching alert notifications
        return of(null);
      })
    );
  }
  private updateBuildingAlertCounts(): void {
    const allBuildings = this.organizationUtilService.data.myBuildings;
    if (!allBuildings) {
      return;
    }

    // Reset counts on all buildings first
    allBuildings.forEach((building: any) => {
      if (building.setAlertCount) {
        building.setAlertCount(0);
      }
    });

    const buildingAlertCounts: { [buildingId: string]: number } = {};
    const myPerimeters = this.organizationUtilService.data.myPerimeters;
    const buildingIdsSet = new Set<string>();
    allBuildings.forEach((b: any) => {
      if (b.perimeterId) buildingIdsSet.add(String(b.perimeterId));
    });

    this.notificationsList.forEach(alert => {
      const buildingsInThisAlert = new Set<string>();
      const perimeterIds = new Set<string>([
        ...(alert.sensorPerimeterIds || []),
        ...(alert.perimeterIds || [])
      ]);

      perimeterIds.forEach(pid => {
        const idStr = String(pid);
        if (buildingIdsSet.has(idStr)) {
          buildingsInThisAlert.add(idStr);
        }

        const perimeter = myPerimeters[idStr] || this.perimterInfo.find(p => String(p.id) === idStr);
        if (perimeter && perimeter.ancestors) {
          perimeter.ancestors.forEach((ancestorId: any) => {
            if (buildingIdsSet.has(String(ancestorId))) {
              buildingsInThisAlert.add(String(ancestorId));
            }
          });
        }
      });

      buildingsInThisAlert.forEach(buildingId => {
        buildingAlertCounts[buildingId] = (buildingAlertCounts[buildingId] || 0) + 1;
      });
    });

    // Now update the building entities
    allBuildings.forEach((building: any) => {
      if (building.type === 'CampusMapEntity' && Array.isArray(building.associatedBuilding)) {
        const campusAlertCount = building.associatedBuilding.reduce((sum: number, associatedBuilding: any) => {
          return sum + (buildingAlertCounts[associatedBuilding.perimeterId] || 0);
        }, 0);
        if (building.setAlertCount) {
          building.setAlertCount(campusAlertCount);
        }
      } else {
        const buildingId = building.perimeterId;
        if (building.setAlertCount) {
          building.setAlertCount(buildingAlertCounts[buildingId] || 0);
        }
      }
    });
  }

  getBuildingInfo(myPerimeters: any[], perimeterId: any, perimeter: any) {
    const buildingInfo: any[] = [];
    //if (!perimeter) continue;
    let floor: any = null;
    let building: any = null;
    if (perimeter.type === 'ROOM') {
      // Find the floor ancestor
      const floors = Object.values(myPerimeters).filter(
        (o: any) => perimeter.ancestors?.includes(o.id) && o.type === 'FLOOR'
      );
      floor = floors.length > 0 ? floors[0] : null;

      if (floor) {
        // Find the building ancestor
        const buildings = Object.values(myPerimeters).filter(
          (o: any) =>
            perimeter.ancestors?.includes(o.id) && o.type === 'BUILDING'
        );

        building = buildings.length > 0 ? buildings[0] : null;
      }
      buildingInfo.push({ building, floor, room: perimeter });
    } else if (perimeter.type === 'FLOOR') {
      // Find the building ancestor
      const buildings = Object.values(myPerimeters).filter(
        (o: any) => perimeter.ancestors?.includes(o.id) && o.type === 'BUILDING'
      );
      building = buildings.length > 0 ? buildings[0] : null;
      buildingInfo.push({ building, floor: perimeter, room: null });
    } else if (perimeter.type === 'BUILDING') {
      buildingInfo.push({ building: perimeter, floor: null, room: null });
    }
    return buildingInfo;
  }
  private getIncidentCountFromOrganizationObservable(): Observable<any> {
    return this.incidentService
      .getIncidentFindAndCountAllFromOrganization()
      .pipe(
        switchMap((response) => {
          if (response && response.rows.length > 0) {
            this.activeincidents = response.rows.length;
            this.incidentDetails = response.rows;

            if (this.incidentDetails && this.incidentDetails.length) {
              // Convert forEach to forkJoin for reactive approach
              const deviceRequests = this.incidentDetails.map((incident) =>
                this.device
                  .getCountDevicesByPerimeterAndStatus(+incident.id)
                  .pipe(
                    tap((statusData) => {
                      // Find building and street data
                      const buildingData = statusData.find(
                        (o: any) => o.type === 'BUILDING'
                      );
                      const streetData = statusData.find(
                        (o: any) => o.type === 'STREET'
                      );

                      let buildingUsers = {
                        danger: 0,
                        safe: 0,
                        unknown: 0,
                      };

                      if (buildingData) {
                        buildingUsers = {
                          danger: buildingData?.danger
                            ? parseInt(buildingData?.danger)
                            : 0,
                          safe: buildingData?.safe
                            ? parseInt(buildingData.safe)
                            : 0,
                          unknown: buildingData?.unknown
                            ? parseInt(buildingData.unknown)
                            : 0,
                        };
                      }

                      let streetUsers = {
                        danger: 0,
                        safe: 0,
                        unknown: 0,
                      };

                      if (streetData) {
                        streetUsers = {
                          danger: streetData.danger
                            ? parseInt(streetData.danger)
                            : 0,
                          safe: streetData.safe ? parseInt(streetData.safe) : 0,
                          unknown: streetData.unknown
                            ? parseInt(streetData.unknown)
                            : 0,
                        };
                      }

                      incident.userStatuses = {
                        danger: buildingUsers.danger + streetUsers.danger,
                        safe: buildingUsers.safe + streetUsers.safe,
                        unknown: buildingUsers.unknown + streetUsers.unknown,
                      };
                    }),
                    catchError((error) => {
                      return of(null);
                    })
                  )
              );

              // Wait for all device requests to complete
              return forkJoin(deviceRequests);
            }
          } else {
            this.activeincidents = 0;
            this.incidentDetails = [];
          }
          return of(null);
        }),
        catchError((error) => {
          return of(null);
        })
      );
  }
  getSensorList() {
    this.dataService.getSensorList().subscribe({
      next: (response) => {
        if (response) {
          return;
        }
      },
      error: (error: Error) => {
        // Error fetching sensor list
      },
    });
  }

  private initializeComponent(): void {
    if (this.isMonitorMode) {
      this.setShowLive(true);
      this.showLive = true;
    } else {
      this.setShowLive(false);
      this.activeTab = TASKS;
    }
  }

  toggleHeader = () => {
    this.isOpen = !this.isOpen;
  };
  showDrawerIcon(): boolean {
    return true;
  }
  showHideDrawer() {
    this.drawerOpen = !this.drawerOpen;
    this.isMonitorMode = !this.isMonitorMode;
  }

  setShowLive(show: boolean): void {
    if (show) {
      this.showLiveTab();
    } else {
      this.showOrgTab();
    }
  }

  updateSessionStyle() {
    switch (this.sessionName) {
      case 'Monitor Mode':
        this.isToggleMenu = true;
        this.isMonitorMode = true;
        this.sessionStyle = { background: '#30323B' };
        this.arcAngelLiveModeService.clearLiveMode();
        this.arcAngelLiveModeService.stopLiveIncidentPoller();
        //this.getAlertNotification();
        //this.getIncidentFromOrganization();
        break;
      case 'Live Mode':
        this.sessionStyle = { background: '#e74c3c' };
        this.isToggleMenu = true;
        this.isMonitorMode = false;
        //this.arcAngelMonitorModeService.removePoller();
        this.stopIncidentPolling();
        break;
      case 'Playback Mode':
        this.isToggleMenu = false;
        this.isMonitorMode = false;
        this.sessionStyle = { background: '#27ae60' };
        break;
      default:
        this.sessionStyle = { background: '#30323B' };
    }
  }

  onSessionNameChange(newName: string) {
    this.sessionName = newName;
    this.updateSessionStyle();
  }
  changeMode() {
    const modalRef = this.modalService.open(SessionOptionsDialogComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          this.onSessionNameChange(result);
        }
      },
      () => { }
    );
  }

  private showLiveTab(): void {
    this.showLive = true;
    this.activeTab = DATAFEED;
  }

  private showOrgTab(): void {
    this.showLive = false;
    this.activeTab = ORG;
  }

  // Tab state checkers
  isDataFeedListActive(): boolean {
    return this.activeTab === DATAFEED;
  }

  isIncidentsActive(): boolean {
    return this.activeTab === INCIDENTS;
  }

  isProcallsActive(): boolean {
    return this.activeTab === PROCALLS;
  }

  isUsersActive(): boolean {
    return this.activeTab === USERS;
  }

  isOrgActive(): boolean {
    return this.activeTab === ORG;
  }

  isBuildingsActive(): boolean {
    return this.activeTab === BUILDINGS;
  }

  isCampusActive(): boolean {
    return this.activeTab === CAMPUS;
  }

  isPerimetersActive(): boolean {
    return this.activeTab === PERIMETERS;
  }

  isUnitsActive(): boolean {
    return this.activeTab === UNITS;
  }

  isDepartmentsActive(): boolean {
    return this.activeTab === DEPARTMENTS;
  }

  isRemotesActive(): boolean {
    return this.activeTab === REMOTES;
  }

  isTravelersActive(): boolean {
    return this.activeTab === TRAVELERS;
  }

  isMessagingActive(): boolean {
    return this.activeTab === MESSAGING;
  }

  isAlertsActive(): boolean {
    return this.activeTab === ALERTS;
  }

  isGeofencesActive(): boolean {
    return this.activeTab === GEOFENCES;
  }

  isTasksActive(): boolean {
    return this.activeTab === TASKS;
  }

  isReportsActive(): boolean {
    return this.activeTab === REPORTS;
  }

  isCalendarActive(): boolean {
    return this.activeTab === CALENDAR;
  }

  isActiveTrackingActive(): boolean {
    return this.activeTab === ACTIVE_TRACKING;
  }

  isCamerasActive(): boolean {
    return this.activeTab === CAMERAS;
  }

  // Tab selection methods
  selectDataFeedList(): void {
    this.activeTab = DATAFEED;
    this.selectedTab = 'alerts';
  }

  selectProcalls(): void {
    this.activeTab = PROCALLS;
    this.selectedTab = 'procalls';
  }

  selectIncidents(): void {
    this.activeTab = INCIDENTS;
    this.selectedTab = 'incidents';
  }

  selectOrg(): void {
    this.activeTab = ORG;
  }

  selectUsers(): void {
    this.activeTab = USERS;
  }

  selectBuildings(): void {
    this.activeTab = BUILDINGS;
  }

  selectCampus(): void {
    this.activeTab = CAMPUS;
  }

  selectPerimeters(): void {
    this.activeTab = PERIMETERS;
  }

  selectGroups(): void {
    this.activeTab = GROUPS;
  }

  selectUnits(): void {
    this.activeTab = UNITS;
  }

  selectDepartments(): void {
    this.activeTab = DEPARTMENTS;
  }

  selectRemotes(): void {
    this.activeTab = REMOTES;
  }

  selectTravelers(): void {
    this.activeTab = TRAVELERS;
  }

  selectMessaging(): void {
    this.activeTab = MESSAGING;
    this.selectedTab = 'messaging';
  }

  selectAlerts(): void {
    this.activeTab = ALERTS;
  }

  selectGeofences(): void {
    this.activeTab = GEOFENCES;
  }

  selectTasks(): void {
    this.activeTab = TASKS;
  }

  selectReports(): void {
    this.activeTab = REPORTS;
  }

  selectCalendar(): void {
    this.activeTab = CALENDAR;
  }

  selectActiveTracking(): void {
    this.activeTab = ACTIVE_TRACKING;
    this.selectedTab = 'tracking';
  }

  selectCameras(): void {
    this.activeTab = CAMERAS;
  }

  toggleUsers(event: Event): void {
    event.stopPropagation();
    this.showUsers = !this.showUsers;
    if (this.homeLocationDataSource) {
      this.homeLocationDataSource.show = this.showUsers;
    }
  }

  toggleFacilities(event: Event): void {
    event.stopPropagation();
    this.showFacilities = !this.showFacilities;
    if (this.organizationUtilService.data && this.organizationUtilService.data.myFacilityPins) {
      const pins = this.organizationUtilService.data.myFacilityPins;
      Object.keys(pins).forEach((id: string) => {
        if (this.showFacilities) {
          pins[id].show();
        } else {
          pins[id].hide();
        }
      });
    }
  }

  toggleRemotes(event: Event): void {
    event.stopPropagation();
    this.showRemotes = !this.showRemotes;
  }

  toggleTravelers(event: Event): void {
    event.stopPropagation();
    this.showTravelers = !this.showTravelers;
  }

  toggleGeofences(event: Event): void {
    event.stopPropagation();
    this.showGeofences = !this.showGeofences;
  }

  toggleStorm(): void {
    this.showStorm = !this.showStorm;
  }

  // Event handlers
  showHideAllianzBuildings(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      // Implement show building layer
    } else {
      // Implement hide building layer
    }
  }

  showHideEarthquake(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      // Implement show earthquake layer
    } else {
      // Implement hide earthquake layer
    }
  }

  showHideDemo2(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      // Implement start demo 2
    } else {
      // Implement end demo 2
    }
  }

  showHideCovid(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      // Implement load covid data
    } else {
      // Implement cleanup covid data
    }
  }

  // UI methods
  openTwitterSearchUi(): void {
    // Implement twitter search UI
  }

  openFlightTrackerUi(): void {
    // Implement flight tracker UI
  }

  getNumberOfNewMessages(): number {
    return 0;
  }

  isInPapi(): boolean {
    return false;
  }

  isProcessingUser(): boolean {
    return false;
  }

  isLoadingPlaybackDevices(): boolean {
    return false;
  }

  isProcessingPlaybackDevices(): boolean {
    return false;
  }

  isStatsPlaybackDevices(): boolean {
    return false;
  }

  getNumberOfSelectedOrgs(): number {
    this.globalSettings.setNumberOfOrganisationFilter(this.numSelectedTopLevel);
    return this.numSelectedTopLevel;
  }

  onOrgSelected(org: Organization): void {
    // Handle organization selection
  }

  onOrgInfoRequested(org: Organization): void {
    // Handle organization info request
  }

  onOrgMessageRequested(org: Organization): void {
    // Handle organization message request
  }

  loadGroupList(): void {
    this.sessionOptionsService.getOrgTree().subscribe({
      next: (result) => {
        this.groupList = result.groups || [];
      },
      error: (err: Error) => {
      },
    });
  }

  selectGroup(group: Group) {
    this.globalSettings.setSelectedGroup(group);
    this.activeTab = group.id + 100;
  }

  isGroupActive(groupId: number): boolean {
    return this.activeTab === groupId + 100;
  }

  showGroupPanel(): boolean {
    return this.activeTab > 100;
  }

  buildOrgTree(): Observable<OrgTreeNode[]> {
    const startTime = Date.now();

    return this.organizationService.getOrgTree().pipe(
      map((results: any) => {
        const groups = results.groups;
        const orgs = results.organizations;

        // Build group list
        const groupList: GroupList = {};
        groups.forEach((group: any) => {
          const list = orgs.filter((org: OrgData) => org.groupId === group.id);
          groupList[group.id] = {
            groupId: group.id,
            selected: true,
            groupName: group.name,
            orgList: list,
          };
        });

        // Get top level orgs
        const topLevelOrgs = this.getTopLevelOrgs(orgs);

        // Calculate user counts
        const orgsUserCount: { [key: string]: number } = {};
        orgs.forEach((org: OrgData) => {
          orgsUserCount[org.id] = 0;
        });

        if (this.users) {
          this.users.forEach((user: any) => {
            if (user.orgIds && Array.isArray(user.orgIds)) {
              user.orgIds.forEach((id: any) => {
                const orgIdNum = Number(id);
                if (orgsUserCount[orgIdNum] !== undefined) {
                  orgsUserCount[orgIdNum]++;
                }
              });
            }
          });
        }

        // Build group nodes
        const groupNodes: OrgTreeNode[] = [];
        Object.values(groupList).forEach((group) => {
          const children: OrgTreeNode[] = [];
          let countForGroup = 0;

          group.orgList.forEach((org: OrgData) => {
            const countForOrg = orgsUserCount[org.id];
            countForGroup += countForOrg;

            const item: OrgTreeNode = {
              name: org.name,
              inputId: 'org' + org.id,
              selected: true,
              parentInputId: 'group' + group.groupId,
              type: 'org' as const,
              organization: org,
              group: group,
              count: countForOrg,
              child: false,
              children: [],
              class: 'childnodetext1',
            };
            children.push(item);
            this._orgTreeItemList.push(item);
          });

          // Sort children by name
          children.sort((a, b) => a.name.localeCompare(b.name));

          const groupParent =
            group.orgList.length > 0
              ? group.orgList[0].parentId
              : topLevelOrgs[0]?.id;

          const groupNode: OrgTreeNode = {
            name: group.groupName,
            inputId: 'group' + group.groupId,
            selected: true,
            parentInputId: 'org' + groupParent,
            type: 'group' as const,
            group: group,
            count: countForGroup,
            child: false,
            children: children,
            class: 'childnodetext1',
          };

          groupNodes.push(groupNode);
          this._orgTreeItemList.push(groupNode);
        });

        // Build top level org tree
        const orgTree: OrgTreeNode[] = topLevelOrgs.map((topLevelOrg) => ({
          name: topLevelOrg.name,
          inputId: 'org' + topLevelOrg.id,
          type: 'org' as const,
          organization: topLevelOrg,
          count: orgsUserCount[topLevelOrg.id],
          child: false,
          children: [],
          class: 'childnodetext1',
          selected: true,
        }));

        this._orgTreeItemList = [...this._orgTreeItemList, ...orgTree];

        // Handle orgs without groupId
        const topLevelOrgIds = topLevelOrgs.map((org) => org.id);
        const orgNoGroup = orgs.filter(
          (org: OrgData) => !org.groupId && !topLevelOrgIds.includes(org.id)
        );

        orgNoGroup.forEach((org: OrgData) => {
          const parent = this._orgTreeItemList.find(
            (item) => item.inputId === 'org' + org.parentId
          );
          if (parent) {
            const item: OrgTreeNode = {
              name: org.name,
              inputId: 'org' + org.id,
              selected: true,
              parentInputId: undefined,
              type: 'org' as const,
              organization: org,
              group: null,
              count: orgsUserCount[org.id],
              child: false,
              children: [],
              class: 'childnodetext1',
            };
            this._orgTreeItemList.push(item);
            parent.children.push(item);
          }
        });

        groupNodes.forEach((groupNode) => {
          const parent = this._orgTreeItemList.find(
            (item) => item.inputId === groupNode.parentInputId
          );
          if (parent) {
            parent.children.push(groupNode);
          }
        });
        this.globalSettings.setOrgTreeItemList(this._orgTreeItemList);
        this.globalSettings.setOrgTreeItemListAll(this._orgTreeItemList);

        this._orgTreeNodes = this.buildOrgTreeNodeDictionary(orgTree);
        this.globalSettings.setOrgTree(orgTree);
        const endTime = Date.now();
        this.createHomeLocationLayer();
        return orgTree;
      }),
      catchError((error) => {
        // Error building org tree
        return throwError(() => error);
      })
    );
  }

  private getTopLevelOrgs(orgs: any[]): any[] {
    const allOrgIds = orgs.map((org) => org.id);
    const topLevelOrgs = orgs.filter(
      (org) => !org.parentId || !allOrgIds.includes(org.parentId)
    );
    return topLevelOrgs;
  }

  private buildOrgTreeNodeDictionary(nodes: any[]): { [key: string]: any } {
    const dict: { [key: string]: any } = {};
    nodes.forEach((node) => {
      dict[node.inputId] = node;
    });
    return dict;
  }
  updateOrgTreeItemList(): void {
    this.numSelectedTopLevel = (this.organizations || []).filter(
      (org) => org.selected === true
    ).length;
    const selectedNodes = this.getSelectedNodes(this.organizations);
    this.globalSettings.setOrgTreeItemList(selectedNodes);
    const selectedOrgIds = selectedNodes.map((node) => node.organization?.id);
    this.globalSettings.setSelectedOrgIds(selectedOrgIds);
  }

  getSelectedNodes(nodes: any[]): any[] {
    if (!nodes) return [];
    let selected: any[] = [];
    nodes.forEach((node) => {
      if (node.selected) {
        selected.push(node);
      }
      if (node.children && node.children.length) {
        selected = selected.concat(this.getSelectedNodes(node.children));
      }
    });
    return selected;
  }

  private createHomeLocationLayer(): void {
    const startTime = Date.now();

    this.sessionOptionsService
      .getArcliveActions()
      .pipe(
        switchMap((actions) => {
          if (!actions.includes('arclive.feature.showHomeLocations')) {
            return of(null);
          }
          return this.sessionOptionsService.getAllHomeLocations();
        })
      )
      .toPromise()
      .then((response: any) => {
        if (!response) {
          return;
        }

        const homeLocationsAll = response.rows;
        this.globalSettings.setHomeLocationsAll(homeLocationsAll);

        const countryList = this.getCountryList(homeLocationsAll);
        this.globalSettings.setCountryList(countryList);

        const homeLocationsAllDictionary: { [key: string]: any } = {};
        _.forEach(homeLocationsAll, (loc) => {
          if (loc && !homeLocationsAllDictionary[loc.userId]) {
            homeLocationsAllDictionary[loc.userId] = loc;
          }
        });
        this.globalSettings.setHomeLocationsAllDictionary(homeLocationsAllDictionary);

        // --- Cesium Home Location Layer Integration ---
        const homeLocationGeoJson = this.createPositionJson(homeLocationsAll);
        var source = new Cesium.GeoJsonDataSource();
        var load = source.load(homeLocationGeoJson);
        Promise.all([load]).then((dataArr) => {
          const data = dataArr[0];
          if (!data) {
            return;
          }

          if (!this.viewer) {
            this.viewer = this.core.getViewer();
            if (!this.viewer) {
              return;
            }
          }
          if (this.homeLocationDataSource) {
            this.viewer.dataSources.remove(this.homeLocationDataSource);
          }
          this.homeLocationDataSource = data;
          this.viewer.dataSources.add(data);
          this.homeLocationDataSource.show = false;
          let pixelSize = 5;
          if (this.viewer.camera.positionCartographic.height <= 10000) {
            pixelSize = 20;
          }
          if (this.viewer.camera.positionCartographic.height > 10000 && this.viewer.camera.positionCartographic.height <= 1000000) {
            pixelSize = 10;
          }
          if (this.viewer.camera.positionCartographic.height > 1000000) {
            pixelSize = 5;
          }

          _.forEach(this.homeLocationDataSource.entities.values, (entity: any) => {
            entity.billboard = undefined;
            entity.name = 'homeLocation';
            entity.point = new Cesium.PointGraphics({
              color: Cesium.Color.BLUE,
              pixelSize: pixelSize,
              outlineColor: Cesium.Color.WHITE,
              outlineWidth: 1
            });
          });

          let endTime = Date.now();
          return;
        }).catch((error) => {
        });
      })
      .catch((error) => {
      });
  }

  private getCountryList(homeLocationsAll: any[]): CountryListItem[] {
    const countryList: string[] = [];

    // Get unique countries
    _.forEach(homeLocationsAll, (loc) => {
      if (loc && loc.country) {
        countryList.push(loc.country);
      }
    });

    const sortedCountries = _.sortBy(countryList);
    const uniqueCountries = _.sortedUniq(sortedCountries);

    // Calculate stats for each country
    const num: { [key: string]: number } = {};
    let numAll = 0;
    const latlon: { [key: string]: any[] } = {};

    _.forEach(uniqueCountries, (code) => {
      num[code] = 0;
      latlon[code] = [];
    });

    _.forEach(homeLocationsAll, (loc) => {
      if (loc && loc.country) {
        num[loc.country]++;
        numAll++;
        latlon[loc.country].push(loc.position);
      }
    });

    // Calculate lat/lon ranges
    const latLonRange: { [key: string]: any } = {};
    _.forEach(latlon, (data, key) => {
      const latArray = data.map((item) => item.coordinates[1]);
      const lonArray = data.map((item) => item.coordinates[0]);

      let maxLat = _.max(latArray);
      let minLat = _.min(latArray);
      let maxLon = _.max(lonArray);
      let minLon = _.min(lonArray);

      // Add padding if min/max are equal
      if (maxLat === minLat) {
        maxLat += 1;
        minLat -= 1;
      }
      if (maxLon === minLon) {
        maxLon += 0.1;
        minLon -= 0.1;
      }

      latLonRange[key] = { maxLat, minLat, maxLon, minLon };
    });

    // Create final list
    const display = 'All (' + numAll + ')';
    const list: CountryListItem[] = [{ name: 'All', code: 'All', display }];

    _.forEach(uniqueCountries, (code) => {
      const display = code + ' (' + num[code] + ')';
      list.push({
        code,
        name: '',
        display,
        latLonRange: latLonRange[code],
      });
    });

    return list;
  }

  private getPixelSizeForCameraHeight(): number {
    const height = this.viewer.camera.positionCartographic.height;
    if (height <= 10000) {
      return 20;
    } else if (height <= 1000000) {
      return 10;
    }
    return 5;
  }

  private createPositionJson(homeLocationsAll: any[]): any {
    const features = homeLocationsAll.map((loc) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: loc.position.coordinates,
      },
      properties: {
        userId: loc.userId,
        country: loc.country,
        region: loc.region,
        place: loc.place,
      },
    }));

    return {
      type: 'FeatureCollection',
      features,
    };
  }

  getNumberOfUsersFiltered(): number {
    return this.globalSettings.getNumberOfUsersFiltered();
  }

  onOrgTreeUpdated(): void {
    this.filterUsersByOrgTree();
  }
  filterUsersByOrgTree(): void {
    this.allUserItems = this.users;
    this.allUserItemsFiltered = this.users;
    if (!this.allUserItems) {
      return;
    }

    const orgTreeItemList = this.globalSettings.getOrgTreeItemList();
    const allOrgIds: string[] = [];
    orgTreeItemList.forEach((org: any) => {
      if (org.type === 'org') {
        allOrgIds.push(org.organization.id);
      }
    });

    let numberOfAllOrgs = 0;
    const orgTreeItemListAll = this.globalSettings.getOrgTreeItemListAll?.() || [];
    orgTreeItemListAll.forEach((item: any) => {
      if (item.type === 'org') {
        numberOfAllOrgs++;
      }
    });

    if (allOrgIds.length === 0) {
      this.allUserItemsFiltered = [];
      Promise.resolve().then(() => {
        this.globalSettings.setNumberOfUsersFiltered(this.allUserItemsFiltered.length);
      });
      return;
    }

    if (allOrgIds.length === numberOfAllOrgs) {
      this.allUserItemsFiltered = this.allUserItems;
      Promise.resolve().then(() => {
        this.globalSettings.setNumberOfUsersFiltered(this.allUserItemsFiltered.length);
      });
      return;
    }

    const users = this.allUserItems.filter(user =>
      this.isUserInOrgTree(user, allOrgIds) && this.isInGeo(user)
    );

    this.allUserItemsFiltered = users;
    Promise.resolve().then(() => {
      this.globalSettings.setNumberOfUsersFiltered(this.allUserItemsFiltered.length);
    });
  }

  private isInGeo(item: User): boolean {
    if (!this.selectedCountry) return true;
    const countryOk = this.selectedCountry.code.toLowerCase() === 'all' || item.geo?.country === this.selectedCountry.code;
    const stateOk = this.selectedState.code.toLowerCase() === 'all states' || item.geo?.region === this.selectedState.code;
    const cityOk = this.selectedCity.code.toLowerCase() === 'all cities' || item.geo?.place === this.selectedCity.code;
    return countryOk && stateOk && cityOk;
  }

  private isUserInOrgTree(user: User, allOrgIds: string[]): boolean {
    return _.intersection(allOrgIds, user.orgIds || []).length > 0;
  }

  onMeasurementToolStateChange(isActive: boolean): void {
    this.isToolActive = isActive;
  }

  onModalOpenStateChange(isOpen: boolean): void {
    // Handle modal open state changes if needed
  }

  onToolStateChange(isActive: boolean): void {
    this.isToolActive = isActive;
  }

  onCloseBuildingCamera() {
    this.entity = null;
    // Reset the flag when closing building camera
    this.cameraService.setHideEventDetailsForLiveNotification(false);
    // Mark building camera as closed
    this.cameraService.setIsBuildingCameraOpen(false);
  }

  // Handler for when the focal point UI is closed
  onCloseFixedPerimeterCreator() {
    this.showFixedPerimeterCreator = false;
    this.fixedPerimeterCreationId = null;
    this.isToolActive = false;
  }
  onPinDialogClosed(result: any) {
    this.showPinDialog = false;
    // If you need to reset tool state after dialog closes, do it here
    setTimeout(() => {
      this.isToolActive = false;
      this.showFixedPerimeterCreator = false;
    });
    // If you need to handle ACTIVATE_AND_GO, do it here
    if (result === 'CAMPUS_ACTIVATE_AND_GO') {
      this.incidentCategoryService.createCampusIncidentAfterDialog().subscribe({
        next: (incidentId) => {
          this.sessionOptionsService.goToLiveIncidentMode(incidentId ?? '', true, true);
          this.arcAngelLiveModeService.startLiveIncidentMode(incidentId ?? '', this);
        }
      });
    } else if (result === 'ACTIVATE_AND_GO') {
      this.incidentCategoryService.createIncidentAfterDialog().subscribe({
        next: (incidentId) => {
          this.sessionOptionsService.goToLiveIncidentMode(incidentId ?? '', true, true);
          this.arcAngelLiveModeService.startLiveIncidentMode(incidentId ?? '', this);
        }
      });
    }
  }
  onOpenPinDialog(dialogData: any) {
    const modalRef = this.modalService.open(PinActivationDialogComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.dialogData = dialogData;
    modalRef.componentInstance.ngOnChanges({
      dialogData: {
        currentValue: dialogData,
        previousValue: null,
        firstChange: true,
        isFirstChange: () => true,
      },
    });
    modalRef.result
      .then((result) => {
        if (result === 'CAMPUS_ACTIVATE_AND_GO') {
          this.incidentCategoryService.createCampusIncidentAfterDialog().subscribe({
            next: (incidentId) => {
              this.sessionOptionsService.goToLiveIncidentMode(incidentId ?? '', true, true);
              this.arcAngelLiveModeService.startLiveIncidentMode(incidentId ?? '', this);
            }
          });
        } else if (result === 'ACTIVATE_AND_GO') {
          this.incidentCategoryService.createIncidentAfterDialog().subscribe({
            next: (incidentId) => {
              this.sessionOptionsService.goToLiveIncidentMode(incidentId ?? '', true, true);
              this.arcAngelLiveModeService.startLiveIncidentMode(incidentId ?? '', this);
            }
          });
        }
      })
      .catch(() => {
      });
  }
  startMonitorModeService() {
    this.arcAngelMonitorModeService.startMonitorMode().subscribe((result) => {
      if (result) {
        this.spinnerService.hide();
      }
    });
  }

  onTimelineClick(event: { arcliveid: any; listid: any }) {
    setTimeout(() => {
      if (this.alertList) {
        this.alertList.handleTimelineClick(event);
      }
    }, 0);
  }

  openGeofenceCreator() {
    this.showGeofenceCreator = true;
    this.isToolActive = true;
    this.adhocMessageWindowVisible = false;
    this.showBuildingCamera = false;
  }

  onGeofenceCreationDone(polygon: number[][]) {
    this.showGeofenceCreator = false;
    this.isToolActive = false;
    this.drawnGeofencePolygon = polygon;
    this.adhocMessageWindowVisible = true;
  }

  onGeofenceCreationCancel() {
    this.showGeofenceCreator = false;
    this.isToolActive = false;
    this.drawnGeofencePolygon = null;
    this.showBuildingCamera = true;
  }

  onSafeZoneStatusChanged(isActive: boolean) {
    // You can store it or use it to toggle UI elements
    this.isAddSafeZone = isActive;
    if (!isActive) {
      this.safeZoneEventId = null;
    }
    this.floorService.setSafeZoneStatus(isActive, this.safeZoneEventId || undefined);
  }
  toggleOrgTreePanel(): void {
    this.showOrgTreePanel = !this.showOrgTreePanel;
    this.updateDrawerPosition();
  }

  closeOrgTreePanel(): void {
    this.showOrgTreePanel = false;
    this.updateDrawerPosition();
  }

  updateDrawerPosition(): void {
    const drawerPanel = document.getElementById('sliding-drawer-plugin-panel');
    if (drawerPanel) {
      drawerPanel.style.left = this.showOrgTreePanel ? '0px' : '-300px';
    }
  }
  onClickNode(node: any) {
    node.__ivhTreeviewIndeterminate = false;
    this.setChildrenStatus(node);
    this.setParentStatus(node, 0);
    this.updateOrgTreeItemList();
  }

  setChildrenStatus(node: OrgTreeNode) {
    if (node.children) {
      node.children.forEach(child => {
        child.selected = node.selected;
        node.__ivhTreeviewIndeterminate = false;
        this.setChildrenStatus(child);
      });
    }
  }

  setParentStatus(node: OrgTreeNode, level: number) {
    if (!node.parentInputId) return;
    const parentNode = this.getNodeById(node.parentInputId);
    if (!parentNode) return;
    const numberOfChildrenSelected = parentNode.children?.filter(child => child.selected).length || 0;

    if (parentNode.type === 'group' && level <= 1) {
      if (numberOfChildrenSelected === parentNode.children.length) {
        parentNode.selected = true;
        parentNode.__ivhTreeviewIndeterminate = false;
      } else if (numberOfChildrenSelected === 0) {
        parentNode.selected = false;
        parentNode.__ivhTreeviewIndeterminate = false;
      } else {
        parentNode.selected = false;
        parentNode.__ivhTreeviewIndeterminate = true;
      }
    }
    this.setParentStatus(parentNode, level + 1);
  }

  getNodeById(id: string): OrgTreeNode {
    return this._orgTreeNodes[id];
  }

  ivhTreeviewBfs(tree: OrgTreeNode[], callback: (node: OrgTreeNode) => void) {
    const queue = [...tree];
    while (queue.length) {
      const node = queue.shift();
      if (!node) continue;
      callback(node);
      if (node.children) queue.push(...node.children);
    }
  }
}
